import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button } from 'reactstrap';
import './AddCertificateModal.css';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import Dropzone from 'react-dropzone';
import { Utils } from '../../../../utils/utils';

class AddCertificateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEnter: false,
            file: null,
            fileContent: null,
            error: false,
        };
    };

    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <ModalBody>
                    <div className='org-certificate-container'>
                        <h5>{_.get(this.props.translation, 'certificate.about_label')}</h5>
                        <Dropzone
                            className='org-certificate-drop-zone'
                            activeClassName='org-certificate-drop-zone-active'
                            onDrop={this.onDrop}
                            multiple={false}
                            onDragEnter={this.onDragEnter}
                            onDragLeave={this.onDragLeave}
                            onClick={this.cleanState}
                        >
                            <div
                                className={'org-certificate-drop-zone-content-container ' + (this.state.isEnter ? 'org-certificate-drop-zone-content-active' : '')}
                            >
                                <h6>{_.get(this.props.translation, 'bulk_upload.drag_and_drop_label')}</h6>
                                <h6>{_.get(this.props.translation, 'bulk_upload.or_label')}</h6>
                                <h6>{Utils.getTagsFromStringWithStyles(_.get(this.props.translation, 'bulk_upload.browse_label'))}</h6>
                            </div>
                        </Dropzone>
                        <h6 className="certificate-result-label">
                            {this.state.error ? _.get(this.props.translation, 'bulk_upload.error_label') : ""}
                            {!_.isNil(this.state.file) ? (_.get(this.props.translation, 'bulk_upload.uploaded_file_label') + ": " + this.state.file.name) : ""}
                        </h6>
                    </div>
                    <div className="modal-buttons-container">
                        <Button color='secondary' onClick={this.props.onCancel}>
                            {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                        </Button>
                        <Button
                            className="olive-green-btn"
                            type="submit"
                            onClick={this.onAddCertificate}
                            disabled={_.isNil(this.state.fileContent)}
                        >
                            {_.get(this.props.translation, 'certificate.add_button')}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    formatIsCorrect = (file) => {
        return file.name.endsWith('.crt');
    };

    onDragEnter = () => {
        this.setState({ isEnter: true });
        this.cleanState();
    };

    onDragLeave = () => {
        this.setState({ isEnter: false });
    };

    onDrop = (filesArray) => {
        this.setState({ isEnter: false });

        if (filesArray.length !== 1) {
            this.setState({ error: true });
            return;
        }

        let file = filesArray[0];
        if (this.formatIsCorrect(file)) {
            this.props.onSetLoading();

            let reader = new FileReader();
            reader.readAsText(file);
            reader.onloadend = () => {
                this.setState({ fileContent: reader.result, file: file });
                this.props.onStopLoading();
            }
        } else {
            this.setState({ error: true });
        }
    };

    cleanState = () => {
        this.setState({
            file: null,
            fileContent: null,
            error: false
        });
    };

    onAddCertificate = () => {
        this.props.onAddCertificate(this.state.fileContent, this.props.orgId || null);
    };
}

AddCertificateModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    orgId: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onAddCertificate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSetLoading: PropTypes.func,
    onStopLoading: PropTypes.func,
};

export default AddCertificateModal;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/certificatesManagement/addCertificateModal/AddCertificateModal.js